import React, { useState, useEffect } from "react";
import Item from "./Item";
import Machine from "./Mch";
import Process from "./Process";
import * as s from "./styles";
import { useInsightwinProcessMaster } from "../../../hooks/useInsightwinProcessMaster";
import Confirmation from "../Confirmation";
import { Alert, Snackbar } from "@mui/material";
import { useGetTableData2 } from "../Plan/tableHooks";
import { useParams } from "react-router-dom";

// 기준정보 - 아이템관리 페이지
function InformationForViewer() {
  const { group_code, project_code } = useParams();
  const [clickedItemId, setClickedItemId] = useState(0);
  const [clickedProcId, setClickedProcId] = useState(0);
  const { processMasterData, orderData } = useInsightwinProcessMaster(
    clickedProcId,
    group_code,
    project_code
  );
  const [confirmationConfig, setConfirmationConfig] = useState({
    isOpen: false,
    title: "",
    mainText: "",
    subText: "",
    onConfirm: () => {},
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'success', 'error', 'warning', 'info'
  });
  const { data, isLoading, isFetching } = useGetTableData2(
    null,
    `/api/item/getAllItems?group_code=${group_code}&project_code=${project_code}`
  );
  const openSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };
  const closeSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };
  const handleShowConfirmation = (config) => {
    setConfirmationConfig({
      isOpen: true,
      ...config,
    });
  };
  const handleCloseConfirmation = () => {
    setConfirmationConfig((prev) => ({
      ...prev,
      isOpen: false,
    }));
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <>
      <s.ContainerViewer>
        <div
          style={{
            width: "95%",
            display: "flex",
            justifyContent: "center",
            gap: "1.4rem",
            height: "100%",
            alignItems: "flex-start",
          }}
        >
          <s.Section>
            <s.SectionContent>
              <Item
                setClickedItemId={setClickedItemId}
                clickedItemId={clickedItemId}
                setClickedProcId={setClickedProcId}
                orderData={orderData}
                onShowConfirmation={handleShowConfirmation}
                openSnackbar={openSnackbar}
                itemData={data}
              />
            </s.SectionContent>
          </s.Section>
          <s.Section>
            <s.SectionContent>
              <Process
                clickedItemId={clickedItemId}
                clickedProcId={clickedProcId}
                setClickedProcId={setClickedProcId}
                orderData={orderData}
                onShowConfirmation={handleShowConfirmation}
                openSnackbar={openSnackbar}
              />
            </s.SectionContent>
          </s.Section>
          <s.Section>
            <s.SectionContent>
              <Machine
                clickedItemId={clickedItemId}
                clickedProcId={clickedProcId}
                processMasterData={processMasterData}
                onShowConfirmation={handleShowConfirmation}
                openSnackbar={openSnackbar}
                orderData={orderData}
                itemData={data}
              />
            </s.SectionContent>
          </s.Section>
        </div>
      </s.ContainerViewer>
      <Confirmation
        isOpen={confirmationConfig.isOpen}
        onClose={handleCloseConfirmation}
        onConfirm={confirmationConfig.onConfirm}
        title={confirmationConfig.title}
        mainText={confirmationConfig.mainText}
        subText={confirmationConfig.subText}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default InformationForViewer;
